import React, { useState } from "react";

// Sub-component to handle individual project logic and loading states
const ProjectCard = ({ project }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <a
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`reveal ${project.delay} group relative rounded-3xl overflow-hidden shadow-soft aspect-[4/3] cursor-pointer bg-gray-100 dark:bg-gray-800`}
        >
            {/* Overlay - Darkens the image slightly for text readability */}
            <div className="absolute inset-0 bg-gray-900/40 group-hover:bg-gray-900/10 transition-colors z-20"></div>

            {/* Skeleton Loader - Only visible until image loads */}
            {!isLoaded && (
                <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 animate-pulse z-10" />
            )}

            {/* Dynamic Website Screenshot */}
            <img
                alt={project.title}
                className={`w-full h-full object-cover object-top transition-all duration-700 group-hover:scale-110 ${
                    isLoaded ? "opacity-100" : "opacity-0"
                }`}
                src={project.image}
                loading="lazy"
                onLoad={() => setIsLoaded(true)}
            />

            {/* Content Info */}
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/90 via-black/40 to-transparent translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500 z-30">
                <h3 className="text-white text-lg font-bold font-display leading-tight">
                    {project.title}
                </h3>
                <p className="text-gray-300 text-[10px] mt-1 mb-4 uppercase tracking-wider">
                    {project.category}
                </p>
                <span className="inline-flex items-center text-primary font-bold text-[9px] bg-white px-3 py-2 rounded-lg uppercase tracking-widest">
                    {project.buttonText}
                </span>
            </div>
        </a>
    );
};

export default ProjectCard